import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'
import {Helmet} from "react-helmet";
import * as config from '../Configuration/Config.js'
import UserProfile from '../Configuration/UserProfile'
import {isMobile,browserName,browserVersion, osName,osVersion} from 'react-device-detect'
import uuid from 'uuid';

class LogIn extends Component {
    constructor() {
        super()

        this.handleEmailChanged = this.handleEmailChanged.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleForgotPassword = this.handleForgotPassword.bind(this)
        this.validatePasswordFormat = this.validatePasswordFormat.bind(this);

        this.state = {
            email_address: '',
            password: '',
            password_is_valid: false,
            password_style_valid: true,
            password_is_confirmed: false,
            password_style_is_confirmed: true,
            rp: '',
            error: '',
            redirectToReferrer: false,
            firstLogin: false,
            redirectToForgotPassword: false
        }
    }

    handleEmailChanged(e){
        return this.setState({email_address: e.target.value});
    }

    handleForgotPassword(event){
        event.preventDefault();
        const that = this;

        let email = this.state.email_address;
        if (!email) {
            alert('Please enter email address');
            return;
        }

        const uri = config.getUriPath('identity/password/forgot')
        const data = {
            user_name: email
        }

        fetch(uri, {
            method: 'post',
            headers: config.ApiHeaders(),
            body: JSON.stringify(data)
        }).then(function(response) {
            if (response.status !== 200) {
                alert('There was an error sending your Forgot Password email');
                return;
            }

            alert('Your forgot password email has been sent');
            that.setState({redirectToForgotPassword: true})
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.state.firstLogin) {
            const np = event.target.elements.NewPassword.value;
            const np2 = event.target.elements.NewPassword2.value;
            
            if (np !== np2) {
                alert('Your conformation password does not match');
                return;
            }
        }

        let email = event.target.elements.EmailAddress.value;
        let uri = config.getUriPath('identity?ue=' 
            + encodeURIComponent(email) 
            + '&qp=' + encodeURIComponent(event.target.elements.Password.value));
        if (this.state.firstLogin) {
            uri += '&np=' + encodeURIComponent(event.target.elements.NewPassword.value);
        }

        var that = this;

        fetch(uri, {
            method: 'get',
            headers: {'Content-Type':'application/json', 'cache-control': 'no-cache no-store'}
           }).then(function(response) {
            if (response.status >= 400) {
                console.log(response);
                that.setState({error: "Server Error, please try again shortly"})
            }

            return response.json();
          })
          .then(function(data) {
            if (!data) {
                that.setState({error: "Invalid username and password"})
                return;
            }

            if (data === "user") {
                that.setState({error: "User not found"})
                return;
            }

            if (data === "password") {
                that.setState({error: "Incorrect password for user"})
                return;
            }

            if (data === "unknown") {
                that.setState({error: "An unknown error ocurred"})
                return;
            }

            if (data === "change") {
                that.setState({error: "An error ocurred changing password"})
                return;
            }

            if (data === "first") {
                that.setState({firstLogin: true})
                return;
            }

            //console.log(config.AuthManager.getToken());

            config.EmailManager.setEmail(email);
            config.AuthManager.setToken(data);
            //console.log(config.AuthManager.getToken());
            // that.setState({redirectToReferrer: true});
            var p = new UserProfile();
            p.loadData(data,
                ()=>{
                    that.setState({redirectToReferrer: true});
                }
            );
          });



        
        
        }

        validatePasswordFormat(e) {
            const password = e.target.value;
            if(password.length < 8 || 
               /[A-Z]+/.test(password) === false || 
               /[!@#\$%\^\&*\)\(+=._-]/.test(password) === false || 
               /[0-9]+/.test(password) === false) {
                return this.setState({password_is_valid: false, password_style_valid: false});
            }
    
            return this.setState({password_is_valid: true, password_style_valid: true, password: password});
        }

    render() {
        if (this.state.redirectToForgotPassword) {
            // const from = { pathname: '/password/forgot' };
            // return <Redirect to={from} />
            return <Redirect to={{
                pathname: '/password/forgot',
                state: { EmailAddress: this.state.email_address }
            }} />        
        }

        if (this.state.redirectToReferrer) {
            var p = new UserProfile();
            var url = p.DefaultPage();
            if (!url) {
                //console.log(this.props.location.state);
                if (!this.props.location.state) {
                    url = "/";
                } else {
                    //console.log(this.props.location.state.from.pathname);
                    url = this.props.location.state.from.pathname;
                }
            }
           
            var varPageEvent = '';
            var varUserIP = '';
            var varUserEmail = '';        
            var varCurrentPage = '';
            var varCurrentDateTime = '';
            var varIsAcumenAdmin = '';
            var varIsCustomerAdmin = '';
            var varCustomerId = '';
            var varUserId = '';
            var varIsMobile = '';
            var varScreenWidth = '';
            var varScreenHeight = '';
            var varBrowserName = '';
            var varBrowserVersion = '';
            var varOSName = '';
            var varOSVersion = '';
            var varSessionID = '';
        
        //PageEvent
        var varPageEvent = 'PAGEVIEW';
        //ip address
        if(sessionStorage.getItem("session_ipaddress") === null)        
        {
            fetch('https://api.ipify.org').then(response => response.text()).then((data)=>{sessionStorage.setItem('session_ipaddress',data)});       
            varUserIP =  sessionStorage.getItem("session_ipaddress");  
        }
        else
        {            
            varUserIP =  sessionStorage.getItem("session_ipaddress");
        }        
        //email address           
        varUserEmail = p.Email();
        //CurrentPage
        varCurrentPage = window.location.href;
        //CurrentDateTime
        varCurrentDateTime = Date.now();
        //IsAcumenAdmin
        varIsAcumenAdmin = p.IsAcumenAdmin();
        //IsCustomerAdmin
        varIsCustomerAdmin = p.IsCustomerAdmin();
        //CustomerId
        varCustomerId = p.CustomerId();
        //UserId
        varUserId = p.UserId();
        //IsMobile
        varIsMobile = isMobile;
        //varScreenWidth
        varScreenWidth = window.innerWidth;
        //varScreenHeight
        varScreenHeight = window.innerWidth;
        varBrowserName = browserName;
        varBrowserVersion = browserVersion;
        varOSName = osName;
        varOSVersion = osVersion;

        if(sessionStorage.getItem("session_id") === null)        
        {           
            sessionStorage.setItem('session_id',uuid.v4());  
            varSessionID = sessionStorage.getItem("session_id");     
        }
        else
        {            
            varSessionID =  sessionStorage.getItem("session_id");
        }                
        console.log('session_id: ' + varSessionID); 
       
        console.log('varPageEvent: ' + varPageEvent);
        console.log('varUserIP: ' + varUserIP);
        console.log('varUserEmail: ' + varUserEmail);       
        console.log('varCurrentPage: ' + varCurrentPage);
        console.log('varCurrentDateTime: ' + varCurrentDateTime );
        console.log('varIsAcumenAdmin: ' + varIsAcumenAdmin);
        console.log('varIsCustomerAdmin: ' + varIsCustomerAdmin);
        console.log('varCustomerId: ' + varCustomerId);
        console.log('varUserId: ' + varUserId);
        console.log('varIsMobile: ' + varIsMobile);
        console.log('varScreenWidth: ' + varScreenWidth);
        console.log('varScreenHeight: ' + varScreenHeight);
        console.log('varBrowserName: ' + varBrowserName);
        console.log('varBrowserVersion: ' + varBrowserVersion);
        console.log('varOSName: ' + varOSName);
        console.log('varOSVersion: ' + varOSVersion);

        var UserMetric = {            
            "PageEvent" : varPageEvent,
            "UserIP" : varUserIP,
            "UserEmail" : varUserEmail,
            "CurrentPage" : varCurrentPage,
            "CurrentDateTime" : varCurrentDateTime,
            "IsAcumenAdmin" : varIsAcumenAdmin,
            "IsCustomerAdmin" : varIsCustomerAdmin,
            "CustomerId" : varCustomerId,
            "UserId" : varUserId,
            "IsMobile" : varIsMobile,
            "ScreenWidth" : varScreenWidth,
            "ScreenHeight" : varScreenHeight,
            "BrowserName" : varBrowserName,
            "BrowserVersion" : varBrowserVersion,
            "OSName" : varOSName,
            "OSVersion" : varOSVersion,
            "SessionID" : varSessionID
        };

        
            let method = 'post';
            let uri = config.getUriPath('usermetric');
            let h = config.ApiHeaders();        
            fetch(uri, {
                method: method,
                headers: h,
                body: JSON.stringify(UserMetric)
            }).then(function(response) {
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }              
            });
            

            const from = { pathname: url };
            //console.log(from);
            return <Redirect to={from} />;
        }

        return <div className="LogIn">
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Login</title>                        
                    </Helmet>                      
                    <div className="center-div-login">
                        <div className="outerLoginBox">
                            {/* <div className="innerLoginBox"> */}
                                <div className="center-h-div">
                                    <img src={require('../../Images/acumen_white.png')} alt="Logo"/>
                                    <div className="loginMessage">Please Login</div> 
                                    <div className="errorMsg">{this.state.error}</div>
                                    <div className="center-div-login">
                                        <form onSubmit={this.handleSubmit}> 
                                            <div className="form-group">
                                                <input 
                                                    name="EmailAddress" 
                                                    placeholder="Email Address"
                                                    onChange={this.handleEmailChanged}
                                                    className="form-control" /><br/>
                                                <input 
                                                    name="Password" 
                                                    type="password"
                                                    placeholder="Password" 
                                                    className="form-control" /><br/>
                                                <div name="divFirstLogin" className={this.state.firstLogin ? '' : 'hidden'}>
                                                        <br/>
                                                        <div>You must enter a new password</div>
                                                        <input 
                                                            name="NewPassword" 
                                                            type="password"
                                                            onChange={this.validatePasswordFormat}
                                                            placeholder="New Password" /><br/>
                                                        <input 
                                                            name="NewPassword2" 
                                                            type="password"
                                                            placeholder="Re-type Password" /><br/>
                                                        <div>Passwords must be at least 8 characters and must contain at least 1 upper case letter, 1 number, and 1 non-alphanumeric character</div>
                                                </div> 
                                                <div className="loginButtonDiv">                                                                                              
                                                    <button className="loginButton btn btn-primary">Log In</button>
                                                    <br/><br/>
                                                    <a href="#" onClick={this.handleForgotPassword}>Forgot Password</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
    }
}

export default LogIn


// WEBPACK FOOTER //
// ./src/Components/Shared/LogIn.js